import calendarRepository from '@/repositories/calendar.repository';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useListCalendarsQuery() {
	return useQuery({
		queryKey: ['calendar', 'list'],
		queryFn: calendarRepository.list,
	});
}

interface IUseGetCalendarQueryArgs {
	id: string;
}

export function useGetCalendarQuery(args: IUseGetCalendarQueryArgs) {
	return useQuery({
		queryKey: ['calendar', 'get', args],
		queryFn: () => calendarRepository.get(args),
	});
}

export function useCreateCalendarMutation() {
	const client = useQueryClient();
	return useMutation({
		mutationFn: calendarRepository.create,
		onSuccess() {
			client.invalidateQueries({ queryKey: ['calendar'] });
		},
	});
}

export function useEditCalendarMutation() {
	const client = useQueryClient();
	return useMutation({
		mutationFn: calendarRepository.create,
		onSuccess() {
			client.invalidateQueries({ queryKey: ['calendar'] });
		},
	});
}

export function useRemoveCalendarMutation() {
	const client = useQueryClient();
	return useMutation({
		mutationFn: calendarRepository.remove,
		onSuccess() {
			client.invalidateQueries({ queryKey: ['calendar'] });
		},
	});
}
